module.exports = __webpack_public_path__ + "img/00052.ac2645cb.webp";